import $ from 'jquery';
import _ from 'lodash';
import constants from 'Constants.js';
import { View, Model } from 'backbone';
import Template from 'properties/table/column-main-custom-parameters.ejs';
import listService      from 'ListService.js';
import SelectFieldModal from 'common-views/SelectFieldModalView.js';
import FormulaModal from 'common-views/MainFormulaModalView';
import sequenceService  from 'SequenceService.js';
import eventBus from 'EventBus.js';
import util from 'util/Util.js';


class MainCustomParametersView extends View {


    initialize( opts ) {
        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;
        this.colId = this.model.get('selectedRowId');
        this.gridEl = constants.PROP_MAIN_TABLE;
        //console.log

        this.events = {
            "click .itemNew"              : "itemNew",
            "click .itemRemove"           : "itemRemove",
            //"click .itemUp"               : "itemUp",
            //"click .itemDown"             : "itemDown",
            "change input[type=checkbox]" : "itemCheck"
        };

        this.model.get('gridData')[this.colId].set({
            colModel: [
                {
                    name: 'name',
                    index: 'name',
                    editable: true
                },
                {
                    name: 'source',
                    index: 'source',
                    editable: false
                },
                {
                    name: 'formula',
                    index: 'formula',
                    edittype: 'checkbox',
                    editoptions: { value:"selected" },
                    formatter: "checkbox",
                    formatoptions: { disabled: false}
                }
            ],
            colNames: ['Name', 'Source', 'Formula']
        }, {silent: true});

        this.loadDataFromCustomParameters();

        if (!util.hasEventListener(eventBus._events, constants.RESIZE_PROPERTIES_STYLE_PANEL)) {
            this.listenTo(eventBus, constants.RESIZE_PROPERTIES_STYLE_PANEL, util.resizeGridWidth);
        }

        return this;
    }

    loadDataFromCustomParameters() {
        this.setGridData([]);
        const parameters = this.model.get('gridData')[this.colId].attributes.CustomParameters.parameter;

        let gridData = this.getGridData();

        for (let param of parameters) {
            let objName = '';
            if(param._value && param._type === 'field'){
                let tableControlName = this.model.get('name');
                let tableControl=listService.getObjectByParam('name',tableControlName);
                let selectedFields = tableControl.model.get('selectFields');
                let fieldWithParameter=_.find(selectedFields,function(item){
                    return item.id === param._value
                });
                if(fieldWithParameter){
                    let controlName=fieldWithParameter.text.substring(0, fieldWithParameter.text.lastIndexOf("-") + 1).replace('-','');

                    objName = `${tableControlName} - ${controlName}`;
                }
            }

            else if (param._value) {
                const id = param._value;
                const obj = listService.getObject(listService.cleanId(id));
                if (obj) {
                    objName = obj ? obj.model.get('name') : '';
                }
            }

            let newRow = {
                'name': param._name,
                'source': param._type === 'expression' ? '[Formula]' : objName,
                'formula': param._type === 'expression' ? 'selected' : ''
            };
            gridData.push(newRow);
        }
        this.setGridData(gridData);
    }

    // Listening on the resize event of the window to call the resizeGrid method on the parent an adapt the grid.
    onResize(){
        $(window).on('resize',() => {this.resizeGrid(); util.makePanelFit();})
    }

    itemCheck(e){

        var i = $(e.currentTarget).closest('tr').index()-1;
        var gridData = this.getGridData();

        if( e.currentTarget.checked ){
            gridData[i].formula = 'selected';
            gridData[i].source = '[Formula]';
            this.model.get('gridData')[this.colId].attributes.CustomParameters.parameter[i]._type = "expression";
            this.model.get('gridData')[this.colId].attributes.CustomParameters.parameter[i]._value = "";
        }
        else{
            gridData[i].formula = '';
            gridData[i].source = '';
            this.model.get('gridData')[this.colId].attributes.CustomParameters.parameter[i]._type = "field";
        }

        this.setGridData(gridData);
        this.render();
    }

    itemNew(){
        var gridData = this.getGridData();
        var length = 0;

        if (gridData) {
            length = gridData.length;
        }

        var newRow = {
            'name':'Item ' + (length+1) ,
            'source': '',
            'formula':  ''
        };
        $(this.gridEl).addRowData((length + 1), newRow);

        gridData.push(newRow);
        this.setGridData(gridData);
        this.model.get('gridData')[this.colId].attributes.CustomParameters.parameter.push({_id: sequenceService.nextDomId() , _name: newRow.name, _type: 'field', _value: ''});

        this.render();
    }

    itemRemove(){
        var gridData = this.getGridData();
        var rowid = this.getRowId();

        this.model.get('gridData')[this.colId].set( gridData.splice(rowid, 1) );
        this.model.get('gridData')[this.colId].attributes.CustomParameters.parameter.splice(rowid,1);
        this.render();
    }

    itemUp(){
        var gridData = this.getGridData();
        var rowid = this.getRowId();

        if ( rowid > 0 ){
            gridData[rowid] = gridData.splice((rowid-1), 1, gridData[rowid])[0];
            this.setRowId(rowid-1);
            this.setGridData(gridData);
            this.render();
        }

    }

    itemDown(){
        var gridData = this.getGridData();
        var rowid = this.getRowId();

        if ( rowid < ( gridData.length-1)){
            gridData[rowid] = gridData.splice((rowid+1), 1, gridData[rowid])[0];
            this.setRowId(rowid+1);
            this.setGridData(gridData);
            console.log(gridData);
            this.render();
        }
    }

    onCellSelect(rowId, iCol, cellcontent, e) {


        const colNames = this.model.get('gridData')[this.colId].get('colNames');
        if (colNames[iCol] !== 'Source' ) {
            return;
        }

        let gridData = this.getGridData();
        let rowIdModel=parseInt(rowId);
        console.log('Current Grid Data',gridData);
        console.log('Current Grid Data Row',gridData[rowIdModel]);
        if (gridData[rowIdModel].formula === 'selected') {
            console.log('Formula Modal Opened');
            let attributes = {formulaParameter: this.model.get('gridData')[this.colId].attributes.CustomParameters.parameter[rowIdModel].Expression };

            let sfModal = new FormulaModal({model: new Model(attributes), config:{viewTitle: "Formula"}});
            sfModal.render().then((formulaParameter)=> {
                this.model.get('gridData')[this.colId].attributes.CustomParameters.parameter[rowIdModel].Expression = formulaParameter;
            });
        }
        else {
            console.log('Select Field Modal Opened');
            let sfModal = new SelectFieldModal({model: this.model, config:{viewTitle: "Select Field"}});
            sfModal.render().then((selectedField)=> {
                gridData[rowIdModel].source = selectedField.name;
                this.setGridData(gridData);
                this.model.get('gridData')[this.colId].attributes.CustomParameters.parameter[rowIdModel]._value = selectedField.id;
                this.render();
            });
        }
    }

    saveCell(rowid, cellname, value){
        var gridData = this.getGridData();
        gridData[rowid][cellname] = value;
        this.setGridData(gridData);

        this.model.get('gridData')[this.colId].attributes.CustomParameters.parameter[rowid]._name = value;
        this.render();
    }

    // Method that renders an scroll in the grid in order to navigate the same on small screens.
    resizeGrid(){
        let grid = $('.ui-jqgrid-btable');
        if (grid) {
            grid.each(function(index) {
                let gridId = $(this).attr('id');
                let gridParentWidth = $('#gbox_' + gridId).parent().width();
                $('#' + gridId).setGridWidth(gridParentWidth);
            });
        }
    }

    setGridData(gridData) {
        this.model.get('gridData')[this.colId].attributes['gridData'] = gridData;
    }
    setRowId(rowId) {
        this.model.get('gridData')[this.colId].attributes['rowid'] = rowId;
    }
    getRowId() {
        return this.model.get('gridData')[this.colId].attributes['rowid'];
    }
    getGridData() {

        var gridData = this.model.get('gridData')[this.colId].attributes['gridData'];
        if (!gridData) {
            gridData = [];
        }

        return gridData;
    }

    render() {
        var gridData = this.getGridData();

        this.$el.empty();
        if (this.template) {
            this.$el.html(this.template(this.model.get('gridData')[this.colId].toJSON()));
        }

        var colModel = this.model.get('gridData')[this.colId].attributes['colModel'];
        var colNames = this.model.get('gridData')[this.colId].attributes['colNames'];
        var self = this;
        $(self.gridEl).jqGrid({
            datatype: "local",
            autowidth: true, 
            shrinkToFit: true,
            altRows: true,
            cellEdit: true,
            cellsubmit: 'clientArray',
            height: 100,
            gridComplete: function () {
                $("tr.jqgrow:odd").css("background", "#DDDDDC");
            },

            //jsonReader : {root: this.model.get('rows') },
            colNames: colNames,
            colModel: colModel,
            onCellSelect: function(rowid, iCol, cellcontent,e){
                self.onCellSelect(rowid, iCol, cellcontent,e);
            },
            beforeSelectRow: function (rowid) {
                self.setRowId(rowid);
            },
            afterSaveCell: function (rowid, cellname, value) {
                console.log('save cell - rowid ' + rowid);
                self.saveCell(rowid, cellname, value);
            }, 
            resizeStop: function(width, index) {
                let columns = $(self.gridEl).jqGrid ('getGridParam', 'colModel');
                let colWidth = columns.filter(c => !c.hidden).reduce((a, c) => a + c.width, 0);

                if ($("#gbox_propMainTable").width() < colWidth) {
                    $(self.gridEl).closest('.ui-jqgrid-bdiv')
                        .css('overflow', '')
                        .addClass('format-table-overflow-shown');
                }
            }
        });

        if (gridData) {
            gridData.forEach(function (value, index) {
                $(self.gridEl).addRowData(index, value);
            });
        }

        this.delegateEvents();

        eventBus.trigger(constants.RESIZE_PROPERTIES_STYLE_PANEL);

        return this;
    }
    
    remove(){
        $(window).off('resize');
        super.remove();
    }
}

export default MainCustomParametersView;
